import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h1> 🔥 Wildfire Tracker (Powered By NASA)</h1>
        </div>
    );
};

export default Header;